var _path, _circle, _circle2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _path2, _path3, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoResults(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 132,
    viewBox: "0 0 230 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137 121.5C171.5 99.684 230 91.5 230 67C230 42.5 212 47.7388 182 35.9999C152 24.261 154.5 -16.5 94.5 8.5C34.5 33.5 0.500059 37.5 0.5 60.5C0.499941 83.5 27.5 81 47 104C66.5 127 102.5 143.316 137 121.5Z",
    fill: "#F4F8FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 183.058,
    cy: 22.0577,
    r: 6.55936,
    transform: "rotate(-164.7 183.058 22.0577)",
    fill: "#F4F8FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.804,
    cy: 26.8036,
    r: 3.91033,
    transform: "rotate(-164.7 199.804 26.8036)",
    fill: "#F4F8FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 50.5393,
    width: 55.7865,
    height: 65.0843,
    rx: 4,
    transform: "rotate(-29.5811 48 50.5393)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60.6766,
    y: 54.0349,
    width: 37.191,
    height: 2.32444,
    rx: 1.16222,
    transform: "rotate(-29.5811 60.6766 54.0349)",
    fill: "#0061FF",
    fillOpacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 66.0306,
    y: 63.469,
    width: 37.191,
    height: 2.32444,
    rx: 1.16222,
    transform: "rotate(-29.5811 66.0306 63.469)",
    fill: "#0061FF",
    fillOpacity: 0.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 63.3533,
    y: 58.7522,
    width: 24.0192,
    height: 2.32444,
    rx: 1.16222,
    transform: "rotate(-29.5811 63.3533 58.7522)",
    fill: "#0061FF",
    fillOpacity: 0.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 71.3855,
    y: 72.9023,
    width: 24.0192,
    height: 2.32444,
    rx: 1.16222,
    transform: "rotate(-29.5811 71.3855 72.9023)",
    fill: "#0061FF",
    fillOpacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 68.7081,
    y: 68.1855,
    width: 17.8207,
    height: 2.32444,
    rx: 1.16222,
    transform: "rotate(-29.5811 68.7081 68.1855)",
    fill: "#0061FF",
    fillOpacity: 0.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 75.9753,
    y: 80.9883,
    width: 37.191,
    height: 15.4963,
    rx: 2,
    transform: "rotate(-29.5811 75.9753 80.9883)",
    fill: "#0061FF",
    fillOpacity: 0.1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 36,
    width: 72,
    height: 84,
    rx: 4,
    fill: "#5897FF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 99.0001,
    y: 48,
    width: 48,
    height: 3,
    rx: 1.5,
    fill: "#3E84F5"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 99.0001,
    y: 62,
    width: 48,
    height: 3,
    rx: 1.5,
    fill: "#3E84F5"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 99.0001,
    y: 55,
    width: 31,
    height: 3,
    rx: 1.5,
    fill: "#3E84F5"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 99.0001,
    y: 76,
    width: 31,
    height: 3,
    rx: 1.5,
    fill: "#3E84F5"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 99.0001,
    y: 69,
    width: 23,
    height: 3,
    rx: 1.5,
    fill: "#3E84F5"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 99.0001,
    y: 88,
    width: 48,
    height: 20,
    rx: 2,
    fill: "#3E84F5"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 160.534,
    y: 101.425,
    width: 3.93034,
    height: 2.94776,
    transform: "rotate(-46.86 160.534 101.425)",
    fill: "#ABCAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M162.685 103.44L165.372 100.572C167.151 100.515 168.88 101.166 170.178 102.383L176.32 108.138C177.203 108.966 177.686 110.134 177.645 111.344L177.636 111.611C177.607 112.455 177.273 113.26 176.695 113.876C176.118 114.492 175.336 114.878 174.496 114.962L174.23 114.988C173.026 115.108 171.828 114.702 170.945 113.874L164.803 108.118C163.505 106.902 162.743 105.219 162.685 103.44Z",
    fill: "#F8FAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.117 100.215C169.538 92.2951 169.134 79.8589 161.215 72.4376C153.295 65.0162 140.859 65.4201 133.438 73.3396C126.016 81.2592 126.42 93.6954 134.34 101.117C142.259 108.538 154.695 108.134 162.117 100.215ZM159.249 97.5272C165.186 91.1916 164.863 81.2426 158.527 75.3055C152.192 69.3684 142.243 69.6915 136.306 76.0272C130.368 82.3628 130.692 92.3118 137.027 98.2488C143.363 104.186 153.312 103.863 159.249 97.5272Z",
    fill: "#D6E4FC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 147.777,
    cy: 86.7771,
    r: 15.7214,
    transform: "rotate(-46.86 147.777 86.7771)",
    fill: "white",
    fillOpacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/no_results.e4c5487a6b5b088d0ca539edee0cf2d4.svg";
export { ForwardRef as ReactComponent };